import React, { FC } from 'react';
import { useEditorContext } from '../../Editor/Context';
import SelectionBubbleMenu from '../SelectionBubbleMenu';
import cn from 'classnames';
import Link from '../buttons/Link';
import {
  LinkBubbleMenuHandlerStorage,
  LinkMenuState,
} from '../../../extensions/extension-link-menu-handler/linkMenuHandler';

export interface Props {
  scrollContainerRef?: React.RefObject<HTMLElement | null>;
}

const GroupAboutBubbleMenu: FC<Props> = ({ scrollContainerRef }) => {
  const editor = useEditorContext();

  if (!editor) {
    return null;
  }

  if (!editor?.isEditable) {
    return null;
  }

  const buttonCount = 1;

  const handlerStorage = editor.storage
    .linkBubbleMenuHandler as LinkBubbleMenuHandlerStorage;
  const menuState = handlerStorage.state;

  let workaroundLinkBubble = false;
  if (menuState === LinkMenuState.VIEW_LINK_DETAILS) {
    workaroundLinkBubble = true;
    return null;
  }

  return (
    <SelectionBubbleMenu
      scrollContainerRef={scrollContainerRef}
      menuHeight={38}
      menuWidth={40 * buttonCount}
      editor={editor}
      open={!editor!.state.selection.empty}
      forceBelowSelection={workaroundLinkBubble}
    >
      <div
        className={cn('ds-surface-tertiary')}
        style={{ maxWidth: '100vw', display: 'flex', flexWrap: 'wrap' }}
      >
        <Link editor={editor} />
      </div>
    </SelectionBubbleMenu>
  );
};
GroupAboutBubbleMenu.displayName = 'GroupAboutBubbleMenu';

export default GroupAboutBubbleMenu;
